import { useSelector } from "react-redux";

const IsEmployer = ({ children }) => {
  const { type } = useSelector((state) => state.user);
  return type === "employer" ? children : null;
};

export default IsEmployer;
